import { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import * as actions from '../../actions/index';
// import thumbnails from '../../data/thumbnails';

import './NavToGroup.css';

class NavToGroup extends Component {
  componentWillMount() {
    //console.log('going to group', this.props.group);
    this.props.goToGroup(this.props.group);
  }
  render() {
    return null;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    goToGroup: (groupID) => {
      dispatch(actions.goToGroup(groupID));
    }
  };
};

NavToGroup.propTypes = {
  group: propTypes.number.isRequired,
};

export default connect(null, mapDispatchToProps)(NavToGroup);



// WEBPACK FOOTER //
// ./src/components/NavToGroup/NavToGroup.js